import { Form } from 'antd'
import React, { useState } from 'react'
import ModuleForm from './components/ModuleForm'
import AdminModuleList from './components/ModuleList';

function ModuleManagement(props) {

    const [form] = Form.useForm();
    const [drawer, setDrawer] = useState(false)
    const [editId, setEditId] = useState(null)

    const onEdit = (record) => {
        form.setFieldsValue({ ...record });
        setDrawer(true)
        setEditId(record.id)
    }

    const drawerToggle = (status) => {

        if (status) {
            form.resetFields()
            setEditId(null)
            setDrawer(true);
            return null
        }

        setDrawer(false)
    }



    return (
        <div className='admin-user-management'>
            <ModuleForm
                form={form}
                drawer={drawer}
                drawerToggle={drawerToggle}
                editId={editId}
            />
            <AdminModuleList onEdit={onEdit} />
        </div>
    )
}

ModuleManagement.propTypes = {

}

export default ModuleManagement

